const UNLEASH_URL = import.meta.env.VITE_UNLEASH_URL;
const UNLEASH_CLIENT_KEY = import.meta.env.VITE_UNLEASH_CLIENT_KEY;
const UNLEASH_APP_NAME = import.meta.env.VITE_UNLEASH_APP_NAME;

export { UNLEASH_URL, UNLEASH_CLIENT_KEY, UNLEASH_APP_NAME };
